import { render } from "./StockValueReports.vue?vue&type=template&id=7d5b8c0a"
import script from "./StockValueReports.vue?vue&type=script&lang=js"
export * from "./StockValueReports.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__